/**
 * @graphql agg
 */

import gql from 'graphql-tag';

import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	preloadMentionsUsersUsersQuery as preloadMentionsUsersUsersQuery$data,
	preloadMentionsUsersUsersQueryVariables as preloadMentionsUsersUsersQuery$variables,
	preloadMentionsUsersUsersQuery_users,
} from './__types__/preloadMentionsUsersUsersQuery.ts';

type UserIdAri = `ari:cloud:identity::user/${string}`;
const ARI_PREFIX = 'ari:cloud:identity::user/';

export const MENTIONS_LOOKUP_LIMIT = 50;

export type MentionUserEntry = {
	id?: string | null;
	name?: string | null;
};

type GetUserDataReturn = (preloadMentionsUsersUsersQuery_users | null)[] | null | undefined;

const getUserData = async (ids: UserIdAri[]): Promise<GetUserDataReturn> => {
	const { data } = await queryAgg<
		preloadMentionsUsersUsersQuery$data,
		preloadMentionsUsersUsersQuery$variables
	>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: gql`
			query preloadMentionsUsersUsersQuery($ids: [ID!]!) {
				users(accountIds: $ids) {
					id
					name
				}
			}
		`,
		variables: {
			ids,
		},
	});

	return data?.users;
};

export const preloadMentionsUsers = async (userIds: string[]): Promise<MentionUserEntry[]> => {
	const ids = userIds.map((id: string) => `${ARI_PREFIX}${id}`) as UserIdAri[];
	const users = await getUserData(ids);

	return (users || []).map((user) => ({
		id: user?.id?.replace(ARI_PREFIX, ''),
		name: user?.name,
	}));
};
